import { CommonModule } from '@angular/common';
import { inject, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DfcoreModule } from '@eredes/dfcore';
import { DSM3Module } from '@eredes/dsm3';
import {
  Dsm34ButtonModule,
  Dsm34FormFieldModule,
  dsm34IconApagar,
  dsm34IconDocumentacao,
  Dsm34ImplicitTemplateModule,
  Dsm34InputModule,
  DSM34SVGModule,
  DSM34SVGRegistry,
  Dsm34UploadModule,
} from '@eredes/dsm34';
import { DFGUIRequestPropFormatPipe } from '@eredes/microservices';
import { MomentModule } from 'ngx-moment';

import { ReplaceAllPipe } from './_pipes/replace-all.pipe';
import { ClaimService } from './_services/claim.service';
import { RequestFormService } from './_services/request-form.service';
import { CancelRequestComponent } from './components/cancel-request/cancel-request.component';
import { DetailTitleComponent } from './components/detail-title/detail-title.component';
import { DocumentHistoryComponent } from './components/document-history/document-history.component';
import { DownloadAttachmentComponent } from './components/download-attachment/download-attachment.component';
import { GeneralDataComponent } from './components/general-data/general-data.component';
import { MessageItemComponent } from './components/message-item/message-item.component';
import { MessageListComponent } from './components/message-list/message-list.component';
import { MultiDownloadAttachmentComponent } from './components/multi-download-attachment/multi-download-attachment.component';
import { ReadMoreComponent } from './components/read-more/read-more.component';
import { ReopenRequestComponent } from './components/reopen-request/reopen-request.component';
import { RequestInformationComponent } from './components/request-information/request-information.component';
import { RequestStateComponent } from './components/request-state/request-state.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { StateLabelComponent } from './components/state-label/state-label.component';
import { SubmissionBarComponent } from './components/submission-bar/submission-bar.component';
import { RequestFormComponent } from './containers/request-form/request-form.component';
import { RequestJumpDetailComponent } from './containers/request-jump-detail/request-jump-detail.component';
import { RequestListJumpComponent } from './containers/request-list-jump/request-list-jump.component';

import { SharedModule } from 'app/_shared/shared.module';

const _DSM34 = [
  Dsm34UploadModule,
  Dsm34FormFieldModule,
  Dsm34InputModule,
  DSM34SVGModule,
  Dsm34ImplicitTemplateModule,
  Dsm34ButtonModule,
];

@NgModule({
  declarations: [
    RequestFormComponent,
    SubmissionBarComponent,
    GeneralDataComponent,
    RequestListJumpComponent,
    RequestJumpDetailComponent,
    DetailTitleComponent,
    RequestInformationComponent,
    RequestStateComponent,
    StateLabelComponent,
    ReadMoreComponent,
    MessageItemComponent,
    MultiDownloadAttachmentComponent,
    DownloadAttachmentComponent,
    MessageListComponent,
    ReopenRequestComponent,
    CancelRequestComponent,
    DocumentHistoryComponent,
    ReplaceAllPipe,
    SearchBarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DSM3Module,
    DfcoreModule,
    MomentModule,
    SharedModule,
    _DSM34,
    DFGUIRequestPropFormatPipe,
  ],
  exports: [RequestFormComponent, RequestListJumpComponent, RequestJumpDetailComponent],
  providers: [RequestFormService, ClaimService, RequestListJumpComponent],
})
export class RequestFormModule {
  private readonly _dsm34IconRegistry = inject(DSM34SVGRegistry);
  constructor() {
    this._dsm34IconRegistry.registerSVGs([dsm34IconDocumentacao, dsm34IconApagar]);
  }
}
